export default {
    // wechatConfig: '/v1/common/wechatsharecfg',
    // thirdLogin: '/v1/wechat/getuserinfo',
    // getInfo: '/v1/user/getmyinfo',
    // wechath5login: '/v1/user/wechath5login',
    // getUploadTokenUrl: '/v1/common/uploadtoken',
    // getTableData: "/api/v1/activityitem/remainderwithoutlogin"
    getTurnTimesData: "/v1/activityitem/remainderwithoutlogin", //不登录活动剩余抽奖次数
    getJoinAcive: "/v1/activityitem/addwithoutlogin",
    getPhoneCode: "/v1/common/smscode", //获取手机验证码
    getLoginApp: "/v1/user/smslogin", //登陆接口
    getPrize: "/v1/activityitem/receiveaward" //领奖啦
        // getPrizeDate


};